// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VZ8gL","short":"styles_short__TUhQl"};